import styles from '../../../styles/sickness.module.scss';
import Button from '../../../components/Button/Button';
import TextField from '../../../components/TextField/TextField';
import { EmployeeSelectionDropdown } from '../../../components/EmployeeSelectionDropdown/EmployeeSelectionDropdown';
import { roleCheckerOtherEmployee } from '../../../utils/roleCheckerOtherEmployee';
import { SicknessHeaderBlockProps } from './types';
import { useSicknessHeaderBlock } from './useSicknessHeaderBlock';
import { formatDateValue } from './helpers/utils';
import useValues from '../../../hooks/useValues';

const SicknessHeaderBlock = (props: SicknessHeaderBlockProps) => {
  const { handleClearClick, handleSickTodayClick, isDisabledSickToday, t } =
    useSicknessHeaderBlock(props);

  const { setHandleValues } = useValues('sicknessData');

  const isManager = roleCheckerOtherEmployee();

  return (
    <div className={styles.subheader}>
      {isManager && (
        <EmployeeSelectionDropdown
          onEmployeeChange={() => {
            setHandleValues({
              type: 'SET_SELECTABLES',
              payload: {
                projectName: 'Select project',
                projectId: null,
              },
            });
            props.updateSicknessList();
          }}
        />
      )}
      <Button
        label={t('buttons.clear') as string}
        styleClass='btn__rounded-blue-narrow'
        onClick={handleClearClick}
        disabled={!props.startDate}
      />
      <div className={styles.datePickerSummaryButton}>
        <TextField
          labelclassname={styles.labelEmpty}
          className={styles.datePickerInput}
          value={formatDateValue(props.startDate)}
          readOnly
        />
        <TextField
          labelclassname={styles.labelEmpty}
          className={styles.datePickerInput}
          value={formatDateValue(props.endDate)}
          readOnly
        />
        <Button
          label={t('buttons.sick_today') as string}
          styleClass='btn__rounded-blue-narrow'
          onClick={handleSickTodayClick}
          disabled={isDisabledSickToday}
        />
      </div>
    </div>
  );
};

export default SicknessHeaderBlock;
